const ALL_GRADIENTS = [
  'blue-skies',
  'lush',
  'learning-and-leading',
  'sweet-morning'
]

export function getRandomGradient () {
  return 'gradient--' + ALL_GRADIENTS[Math.floor(Math.random() * ALL_GRADIENTS.length)]
}
